export const AGGREGATE_ROW = 'aggregate-row';
export const HEADER_ROW_HEIGHT = 24;
